const appBaseUrl = document.head.querySelector('meta[name="app-base-url"]').content

export default {
  envState: process.env.NODE_ENV,
  apiBaseUrl: process.env.NODE_ENV === 'production' ? (appBaseUrl.endsWith('/') ? appBaseUrl.slice(0, -1) : appBaseUrl) : 'http://070crm.test',
  apiVersion: 'v1'
}
